import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {Constants} from '../../../constants/ebtq-constants';
import {UpdateLookupVo} from '../../../model/updateLookupVo';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {UserDetailsModel} from '../../../constants/userModel';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-fhamax-claim-amount',
  templateUrl: './fhamax-claim-amount.component.html',
  styleUrls: ['./fhamax-claim-amount.component.scss']
})
export class FHAMaxClaimAmountComponent implements OnInit {

  state!: any[];
  selectedState!: string;
  currentVal!: string;
  showVal = false;
  displayState!: string;
  updatVal: string;
  successMess: boolean;
  showErrorDiv: boolean;
  errHeading: string;
  errMessage!: string;
  containsError = false;
  errorMsg!: string;
  userDetails: UserDetailsModel;
  title = 'Update MAX Claim Amount Table';

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.successMess = false;
    this.showErrorDiv = false;
    this.updatVal = '';
    this.userDetails = Constants.USER_DETAILS;
    this.errHeading = Constants.ERROR_HEADER;
  }

  getStateList() {
    this.apiService.getMaxAmtStateList()
      .subscribe(
        (data: any) => {
          this.state = [];
          for (const stateName of data) {
            this.state.push({label: stateName, value: stateName});
          }
          this.selectedState = data[0];
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorAnnouncement();
  }

  getMaxAmtLimit() {
    this.apiService.getMaxAmtLimit(this.selectedState)
      .subscribe(
        (data: any) => {
          this.showVal = true;
          this.displayState = this.selectedState;
          this.currentVal = data;
          this.updatVal = '';
          this.successMess = false;
          this.showErrorDiv = false;
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorAnnouncement();
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.getStateList();
  }

  updateMaxClaimAmt() {
    const rgx = /^[0-9]*\.?[0-9]*$/;
    this.successMess = false;
    this.showErrorDiv = false;
    if (this.updatVal.trim() === '') {
      this.showErrorDiv = true;
      this.errMessage = Constants.MAX_CLAIM_EMPT_MESS;
    } else if (this.updatVal.trim().match(rgx)) {
      const request = new UpdateLookupVo();
      request.stateName = this.selectedState;
      request.userID = this.userDetails.uid;
      request.gseAmt = this.updatVal;
      this.apiService.updateMaxAmtLimit(request)
        .subscribe((data: any) => {
          if (data === 1) {
            this.currentVal = this.updatVal;
            this.successMess = true;
          } else {
            this.showErrorDiv = true;
            this.errMessage = Constants.SOMETHING_MESS;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

      // error announcement
      this.errorAnnouncement();
    } else {
      this.errMessage = Constants.MAX_CLAIM_INCRT_FRMT_MESS;
      this.showErrorDiv = true;
    }
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        if (message.includes('Unable to update')) {
          this.showErrorDiv = true;
          this.errMessage = Constants.UNEXPCT_ERROR;
        } else {
          this.errorMsg = message;
          this.containsError = true;
        }
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e: KeyboardEvent) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.updateMaxClaimAmt();}
  }

}
